import React, { useEffect, useState } from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Logo from '../assets/logo.png';
import Swal from "sweetalert2";

const Deliverynote_detailsView = () => {
    useAuthRedirect();
    const { delNo } = useParams();

    // Separate state for header and item details
    const [headerDetails, setHeaderDetails] = useState({});
    const [itemDetails, setItemDetails] = useState([]);

    useEffect(() => {
        const fetchDetails = async () => {
            if (!delNo) {
                console.log("No Delivery Note Number (delNo) provided");
                return;
            }
            try {
                Swal.fire({
                    title: "Fetching Delivery Note Details",
                    html: `
                        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                        <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                        </div>
                        <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Delivery Note Details...</p>
                    `,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        const style = document.createElement("style");
                        style.innerHTML = `
                        @keyframes progressBar {
                            0% { width: 0% }
                            50% { width: 100% }
                            100% { width: 0% }
                        }
                        `;
                        document.head.appendChild(style);
                    },
                    });
                
                console.log(`Fetching details for Delivery Note No: ${delNo}`);
                const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/deliveryNote_detail?delNo=${delNo}`);

                console.log("API Response:", response.data);
                
                if (response.data && response.data.deliveryDetail?.length > 0) {
                    const items = response.data.deliveryDetail; 

                    const header = {
                        del_no: items[0].del_no,
                        tobranch: items[0].tobranch,
                        del_supplier: items[0].del_supplier,
                        del_send: items[0].del_send || "N/A",
                        del_date: items[0].del_date || "N/A",
                    };

                    setHeaderDetails(header);
                    setItemDetails(items);

                  
                } else {
                    console.warn("API Response does not contain expected data structure");
                }
                Swal.close();
            } catch (error) {
                 Swal.close();
                console.error("Error fetching Delivery Note Details. Please try again:", error);
                Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "Error fetching Delivery Note Details. Please try again",
                });
            }
        };

        fetchDetails();
    }, [delNo]);

    return (
        <div className="delivery-note-container">
            {/* Header Section */}
            <div className="header">
                <div className="logo">
                    <img src={Logo} alt="Company Logo" />
                </div>
                <div className="company-info">
                    <h2>SRC PROJECTS PRIVATE LIMITED</h2>
                    <p>
                        4-B, LAKSHMIPURAM, GANDHI ROAD, SALEM-636 007.
                        <br />
                        Ph: 0427-2312433, 2319140 | Fax: 0427-2312623, 2312622 |
                        <strong> E-mail: excavt@eih.net</strong>
                    </p>
                </div>
            </div>

            {/* Delivery Details */}
            <div className="delivery-details">
                <div className="left">
                    <p><strong>To:</strong> {headerDetails?.tobranch ? headerDetails.tobranch : headerDetails?.del_supplier || "N/A"}</p>
                    <p><strong>Send Through:</strong> {headerDetails?.del_send || "N/A"}</p>
                </div>
                <div className="right">
                    <p><strong>Delivery Note:</strong> {headerDetails?.del_no || "N/A"}</p>
                    <p><strong>Date:</strong> {headerDetails?.del_date ? new Date(headerDetails.del_date).toLocaleDateString('en-GB') : "N/A"}</p>
                </div>
            </div>

            {/* Items Table */}
            <table className="items-table">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Descriptions</th>
                        <th>Specification / Part Number</th>
                        <th>UM</th>
                        <th>Del.Qty</th>
                        <th>Rec.Qty</th>
                        <th>Bal.Qty</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {itemDetails.length > 0 ? (
                        itemDetails.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item?.del_description || "N/A"}</td>
                                <td>{item?.del_specification || "N/A"}</td>
                                <td>{item?.del_UM || "N/A"}</td>
                                <td>{item?.Del_Qty || 0}</td>
                                <td>{item?.Rec_Qty || 0}</td>
                                <td>{item?.Bal_Qty || 0}</td>
                                <td>{item?.del_remarks || "N/A"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" style={{ textAlign: "center" }}>No items found</td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Footer Section */}
            <div className="footer">
                <p><strong>Remarks:</strong></p>
                <div className="signature-section">
                    <p><strong>Delivered By</strong></p>
                    <p><strong>Approved By</strong></p>
                    <p><strong>Received By</strong></p>
                </div>
            </div>

            <div className="print-button-container no-print">
  <button onClick={() => window.print()} className="print-btn">
    🖨️ Print 
  </button>
</div>

        </div>
    );
};

export default Deliverynote_detailsView;
